<h1 mat-dialog-title>Escolha o tipo de arquivo</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 500px;">
    <div class="row mt-4">
        <div *ngIf="data.bPDF" class="col-sm">
            <button type="button" class="btn btn-danger" (click)="exportar(0)">
                <div class="config">
                    <img src="./assets/file-pdf-solid.svg">
                    <span style="margin-left: 5px; margin-top: 25px;"> .PDF</span>
                </div>
            </button>
        </div>
        <div *ngIf="data.bExcel" class="col-sm">
            <button type="button" class="btn btn-success" (click)="exportar(1)">
                <div class="config">
                    <img src="./assets/file-excel-solid.svg">
                    <span style="margin-left: 5px; margin-top: 25px;"> .EXCEL</span>
                </div>
            </button>
        </div>
        <div *ngIf="data.bCSV" class="col-sm">
            <button type="button" class="btn btn-info" (click)="exportar(2)">
                <div class="config">
                    <img src="./assets/file-csv-solid.svg">
                    <span style="margin-left: 5px; margin-top: 25px;"> .CSV</span>
                </div>
            </button>
        </div>
    </div>
</div>